import React, { useRef, useEffect } from "react";
import PropTypes from "prop-types";

/**
 * Detects when a click event happens outside of the child component
 */
const OutsideAlerter = ({ onOutside, children }) => {
    const wrapperRef = useRef(null);

    useEffect(() => {
        /**
         * Alert if clicked on outside of element
         */
        const handleClickOutside = (event) => {
            if (
                wrapperRef.current &&
                !wrapperRef.current.contains(event.target)
            ) {
                onOutside();
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [onOutside]);

    return <div ref={wrapperRef}>{children}</div>;
};

OutsideAlerter.propTypes = {
    onOutside: PropTypes.func.isRequired,
    children: PropTypes.element.isRequired,
};

export default OutsideAlerter;
